import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/Store";
import { useParams } from "react-router-dom";
import { getNotificationDetail } from "../../features/emailNotifications";

interface EditorProp{
  onValueChange:any,
  forUpdate:boolean

}

const MyEditor:React.FC<EditorProp> = ({ onValueChange,forUpdate }) => {
  


  const [value, setValue] = useState("");
  const detail:any = useSelector(
    (state:RootState) => state.emailNotifications.emailNotificationDetail
  );
  // console.log(detail);

  

  useEffect(() => {
    if(forUpdate){
      if (Object.keys(detail).length !== 0) {
      setValue(detail.emailBody);
      }
    }
  }, [detail]);
  

  onValueChange(value);

  const editorStyle = {
    height: "300px",
  };
  

  return (
    <ReactQuill
      theme="snow"
      placeholder="Write Something..."
      value={value}
      style={editorStyle}
      onChange={setValue}
    />
  );
};

export default MyEditor;
